export default __webpack_public_path__ + "static/media/ecpsr-logo-colored.d8176b0c.png";